module.exports = __webpack_public_path__ + "img/icon-close-squared.01d24d41.svg";